import React from 'react';

type Props = {
  width?: number;
  height?: number;
  color?: string;
};

const IconMoneyBill: React.FC<Props> = ({
  width = 20,
  height = 20,
  color = '#3E454D',
}: Props) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 6.8763C8.27667 6.8763 6.875 8.27797 6.875 10.0013C6.875 11.7246 8.27667 13.1263 10 13.1263C11.7233 13.1263 13.125 11.7246 13.125 10.0013C13.125 8.27797 11.7233 6.8763 10 6.8763ZM10 11.8763C8.96583 11.8763 8.125 11.0355 8.125 10.0013C8.125 8.96714 8.96583 8.1263 10 8.1263C11.0342 8.1263 11.875 8.96714 11.875 10.0013C11.875 11.0355 11.0342 11.8763 10 11.8763ZM15 3.54297H5C2.985 3.54297 1.875 4.65297 1.875 6.66797V13.3346C1.875 15.3496 2.985 16.4596 5 16.4596H15C17.015 16.4596 18.125 15.3496 18.125 13.3346V6.66797C18.125 4.65297 17.015 3.54297 15 3.54297ZM16.875 13.3346C16.875 14.6488 16.3142 15.2096 15 15.2096H5C3.68583 15.2096 3.125 14.6488 3.125 13.3346V6.66797C3.125 5.3538 3.68583 4.79297 5 4.79297H15C16.3142 4.79297 16.875 5.3538 16.875 6.66797V13.3346ZM5.83333 10.0013C5.83333 10.4613 5.46 10.8346 5 10.8346C4.54 10.8346 4.16667 10.4613 4.16667 10.0013C4.16667 9.5413 4.54 9.16797 5 9.16797C5.46 9.16797 5.83333 9.5413 5.83333 10.0013ZM15.8333 10.0013C15.8333 10.4613 15.46 10.8346 15 10.8346C14.54 10.8346 14.1667 10.4613 14.1667 10.0013C14.1667 9.5413 14.54 9.16797 15 9.16797C15.46 9.16797 15.8333 9.5413 15.8333 10.0013Z"
      fill={color}
    />
  </svg>
);

export default IconMoneyBill;
